import * as Routes from '../../scripts/routes';
import { notification } from 'antd';
import sortable from "html5sortable/dist/html5sortable.es"
import _isEmpty from 'lodash/isEmpty';

do ->
  'use strict'

  # ANGULAR CONTROLLER FUNCTION
  ProcessoWorkflowNewEditController = ($http, $scope, $timeout) ->
    vm = @

    # CONSTANTS


    # VARIABLES VIEW MODEL
    vm.assuntos        = []
    vm.loadingAssuntos = false
    vm.loadingTipos    = false

    vm.showPasso1 = false
    vm.showPasso2 = false
    vm.showPasso3 = false
    vm.showPasso4 = false
    vm.showPasso5 = false
    vm.showPasso6 = false

    vm.check_list_item            = ''
    vm.check_list                 = []
    vm.check_list_avancado        = []
    vm.manual_obrigatorio         = null
    vm.documentos_mode            = 'manual'
    vm.documentos_mode_source     = 'auto'
    vm.documentos_modes           = [
      { label: 'USAR CHECKLIST', value: 'checklist' }
      { label: 'CRIAR LISTA PRÓPRIA', value: 'manual' }
    ]
    vm.form                       = {documentos: {check_list: null, check_list_avancado: null}}    
    vm.setores_sem_telefones      = []
    vm.current_setor_sem_telefone = false
    vm.route_telefone_setor       = null
    vm.checklist_documentos       = []
    vm.checklist_documentos_tipo  = null
    vm.tiposProcesso              = []
    vm.form_loaded                = false

    # VARIAVEIS PRIVATE


    # WATCHES

    # CHANGE SELECT TIPO PROCESSO
    $scope.$watch (->
      vm.form.tipo_id
    ), (current, _original) ->
      if current?
        id = current?.id || current
        vm.form.tipo_id = parseInt(id) unless current?.id?
        setAssuntos(parseInt(id))
      else
        vm.form.tipo_id    = null
        vm.form.assunto_id = null

    # WATCH CHECK LIST
    $scope.$watchCollection (->
      vm.check_list
    ), (current, _original) ->
      if current.length > 1
        setupSortable()

    # CHANGE MANUAL DOCUMENT TYPE
    $scope.$watch (->
      vm.manual_obrigatorio
    ), (current, original) ->
      return unless current?
      return unless original? && current != original

      vm.check_list_item = ''
      vm.check_list = []
      vm.check_list_avancado = []
      return

    # WATCH CHECK LIST AVANCADO
    $scope.$watchCollection (->
      vm.check_list_avancado
    ), (current, original) ->
      if current.length > 1
        setupSortable()


    # CHANGE SELECT SETOR ID
    $scope.$watch (->
      vm.form.setor_id
    ), (current, _original) ->
      if current?
        checkSetorSemTelefone(current)
        setRouteTelefoneSetor(current)

    # CHANGE TIPO AND ASSUNTO ID
    $scope.$watchCollection (->
      [parseInt(vm.form.tipo_id), parseInt(vm.form.assunto_id?.id)]
    ), (current, _original) ->
      if current[0] && current[1]
        carregarChecklistDisponivel({
          tipo_id:    current[0],
          assunto_id: current[1]
        })
        $timeout((-> $('#processo_workflow_documentos_obrigatorio').select2()), 50)

    # # CHANGE SISTEMA
    $scope.$watch (->
      vm.form.sistema
    ), (current, _original) ->
        if current?
          if vm.form_loaded && _original? && current != _original
            vm.form.tipo_id = null
            vm.form.assunto_id = null
            vm.documentos_mode = 'manual'
            vm.documentos_mode_source = 'auto'
            vm.manual_obrigatorio = null
            vm.checklist_documentos = []
            vm.checklist_documentos_tipo = null
            vm.check_list_item = ''
            vm.check_list = []
            vm.check_list_avancado = []
            vm.form.documentos ?= {}
            vm.form.documentos.obrigatorio = undefined
            vm.form.documentos.check_list = null
            vm.form.documentos.check_list_avancado = null
            vm.form.documentos.origem_documentos = 'manual'
        checkTiposProcesso(current)

    # METHODS PRIVATE
    isVirtualSystem = ->
      vm.form.sistema == false || vm.form.sistema == 'false'

    isEvolucaoSystem = ->
      vm.form.sistema == true || vm.form.sistema == 'true'

    normalizeInitialIds = ->
      vm.form.sistema = vm.form.sistema.toString() if vm.form.sistema?
      vm.form.tipo_id = parseInt(vm.form.tipo_id) if vm.form.tipo_id? && !vm.form.tipo_id?.id?
      if vm.form.assunto_id? && !vm.form.assunto_id?.id?
        vm.form.assunto_id = { id: parseInt(vm.form.assunto_id) }
      return

    setupSortable = ->
      $timeout((->
        sortable('.sortable', {
          forcePlaceholderSize: true,
          placeholderClass:     'ph-class',
          hoverClass:           'bg-maroon yellow'
        })
      ), 200)

    refreshDocumentosModeSelect = ->
      $timeout((->
        $el = $('#processo_workflow_documentos_origem_documentos')
        return unless $el.length

        if $el.hasClass('select2-hidden-accessible')
          $el.select2('destroy')

        $el.select2({
          dropdownParent: $('#modal-remote-only-body-full')
        })
        $el.val(vm.documentos_mode).trigger('change')
      ), 50)

    hydrateManualDocumentos = ->
      vm.manual_obrigatorio = vm.form.documentos?.obrigatorio if vm.form.documentos?.obrigatorio?
      vm.check_list = angular.copy(vm.form.documentos?.check_list || [])
      vm.check_list_avancado =
        (angular.copy(vm.form.documentos?.check_list_avancado || [])).map (item) ->
          item.quantidade = parseInt(item.quantidade)
          item

      return

    hasManualDocumentos = ->
      return (vm.form.documentos?.check_list?.length > 0) || (vm.form.documentos?.check_list_avancado?.length > 0) || vm.form.documentos?.obrigatorio?

    hasChecklistDocumentos = ->
      return vm.checklist_documentos.length > 0 && isVirtualSystem()

    loadChecklistDocumentosFromCurrentSelection = ->
      return unless isVirtualSystem()

      tipo_id = vm.form.tipo_id?.id || vm.form.tipo_id
      assunto_id = vm.form.assunto_id?.id || vm.form.assunto_id
      return unless tipo_id? && assunto_id?

      carregarChecklistDisponivel({
        tipo_id:    parseInt(tipo_id)
        assunto_id: parseInt(assunto_id)
      })

      return

    applyChecklistDocumentos = (documentos = {}) ->
      documentos = angular.fromJson(documentos) if angular.isString(documentos)

      checkList = angular.copy(documentos.check_list || [])
      docType   = documentos.obrigatorio || documentos.tipo
      docType   = docType.toString() if docType?
      vm.checklist_documentos = checkList
      vm.checklist_documentos_tipo = docType || null

      if docType == 'variado'
        vm.checklist_documentos = checkList.map (item) ->
          item.quantidade = parseInt(item.quantidade)
          item
      else if docType == 'true' || docType == 'obrigatorio'
        vm.checklist_documentos = checkList.map((item) ->
          if angular.isObject(item)
            item
          else
            { nome: item, quantidade: '1', obrigatorio: 'true' }
        )

      return

    carregarChecklistDisponivel = (params) ->
      $http.get(Routes.abertura_regras_documentos_checklist_documentos_path(params), {cache: true}).then ((result) ->
        if(result.status == 200)
          data = result.data || {}
          data = angular.fromJson(data) if angular.isString(data)
          applyChecklistDocumentos(data)
          setupSortable() if vm.checklist_documentos.length > 1
          $timeout((-> $('#processo_workflow_documentos_origem_documentos').select2()), 50) if vm.checklist_documentos.length > 0

          if vm.form.documentos?.origem_documentos?
            vm.documentos_mode = vm.form.documentos.origem_documentos
            hydrateManualDocumentos() if vm.documentos_mode == 'manual'
            refreshDocumentosModeSelect()
          else if hasManualDocumentos()
            vm.documentos_mode = 'manual'
            vm.form.documentos ?= {}
            vm.form.documentos.origem_documentos = 'manual'
            hydrateManualDocumentos()
            refreshDocumentosModeSelect()
          else if vm.checklist_documentos.length > 0
            vm.documentos_mode = 'checklist'
            vm.form.documentos ?= {}
            vm.form.documentos.origem_documentos = 'checklist'
            refreshDocumentosModeSelect()
          else if vm.documentos_mode == 'checklist' && !vm.checklist_documentos.length
            vm.documentos_mode = 'manual'
            vm.form.documentos ?= {}
            vm.form.documentos.origem_documentos = 'manual'
            refreshDocumentosModeSelect()
      ), (_error) ->
        vm.checklist_documentos      = []
        vm.checklist_documentos_tipo = null
        if vm.documentos_mode == 'checklist'
          vm.documentos_mode = 'manual'
          refreshDocumentosModeSelect()

      return

    onDocumentosModeChange = ->
      vm.form.documentos ?= {}
      vm.form.documentos.origem_documentos = vm.documentos_mode
      vm.documentos_mode_source = 'user'

      if vm.documentos_mode == 'checklist'
        loadChecklistDocumentosFromCurrentSelection()
      else
        $timeout((-> $('#processo_workflow_documentos_obrigatorio').select2()), 50)
      return

    # INIT SETUP
    init = () =>
      hydrateManualDocumentos()

      vm.documentos_mode =
        vm.form.documentos?.origem_documentos ||
        (if hasManualDocumentos() then 'manual' else 'manual')

      vm.documentos_mode_source = if vm.form.documentos?.origem_documentos? then 'saved' else 'auto'

      hydrateManualDocumentos() if vm.documentos_mode == 'manual'
      normalizeInitialIds()
      refreshDocumentosModeSelect()
      $timeout((-> loadChecklistDocumentosFromCurrentSelection()), 0)
      $timeout((-> vm.form_loaded = true), 0)
      return

    checkTiposProcesso = (params) ->
      vm.loadingTipos   = true
      vm.tiposProcesso  = [['CARREGANDO...', 99999]]
      $http.get(Routes.get_tipos_processos_workflows_path({sistema: params}), {cache: true}).then ((result) ->
        if(result.status == 200)
          vm.tiposProcesso = result.data.tipos
          $timeout((-> recarregarSelectTipo()), 50)
        else
          notification.warning({
            message:     'Atenção',
            description: 'Não foi possível processar o pedido.',
            duration:    10,
            placement:   'bottomRight'
          })
        vm.loadingTipos = false
      ), (error) ->
        vm.loadingTipos = false
        notification.error({
          message:     'Erro',
          description: error.data.message,
          duration:    10,
          placement:   'bottomRight'
        })
      return

    setRouteTelefoneSetor = (setor_id) ->
      vm.route_telefone_setor = Routes.telefones_setores_path(filter: setor_id)
      return

    recarregarSelectTipo = ->
      setTimeout ->
        $el = $('#processo_workflow_tipo_id')
        return unless $el.length

        if $el.hasClass('select2-hidden-accessible')
          $el.select2('destroy')

        $el.select2()

        if vm.form.tipo_id?
          $el.val(vm.form.tipo_id.toString()).trigger('change')
      , 0
      return

    setAssuntos = (tipo_id) ->
      if tipo_id? && tipo_id != ""
        vm.loadingAssuntos = true
        vm.assuntos        = [{nome: 'CARREGANDO...'}]
        $http.get(Routes.assuntos_processos_path({'tipo_id': tipo_id, 'sistema': vm.form.sistema}), {cache: true}).then ((result) ->
          if(result.status == 200)
            vm.assuntos = result.data
            selectedAssuntoId = vm.form.assunto_id?.id || vm.form.assunto_id
            if selectedAssuntoId?
              vm.form.assunto_id = vm.assuntos.find((assunto) -> parseInt(assunto.id) == parseInt(selectedAssuntoId)) || {id: parseInt(selectedAssuntoId)}
          else
            notification.warning({
              message:     'Atenção',
              description: 'Não foi possível processar o pedido.',
              duration:    10,
              placement:   'bottomRight'
            })
          vm.loadingAssuntos = false
        ), (error) ->
          vm.loadingAssuntos = false
          notification.error({
            message:     'Erro',
            description: error.data.message,
            duration:    10,
            placement:   'bottomRight'
          })
      return


    checkSetorSemTelefone = (setor_id) ->
      vm.current_setor_sem_telefone = parseInt(setor_id) in vm.setores_sem_telefones
      vm.current_setor_sem_telefone = false if isEvolucaoSystem()
      return

    # METHODS VIEW MODEL
    vm.canPasso1 = ->
      return vm.showPasso1

    vm.canPasso2 = ->
      return vm.form.sistema && vm.canPasso1()

    vm.canPasso3 = ->
      return vm.form.evento && vm.canPasso2()

    vm.canPasso4 = ->
      return vm.form.tipo_id && vm.canPasso3()

    vm.canPasso5 = ->
      return vm.form.assunto_id && vm.canPasso4()

    vm.canPasso6 = ->
      return vm.form.setor_id && vm.canPasso5()

    vm.canSubmit = ->
      return vm.form.evento &&
        vm.form.tipo_id &&
        vm.form.assunto_id &&
        vm.form.setor_id &&
        (
          (vm.documentos_mode == 'checklist' && !_isEmpty(vm.checklist_documentos) && vm.checklist_documentos_tipo?) ||
          (vm.documentos_mode == 'manual' && vm.manual_obrigatorio? && (
            vm.manual_obrigatorio == 'false' ||
            vm.manual_obrigatorio == false ||
            (vm.manual_obrigatorio == 'true' || vm.manual_obrigatorio == true) && vm.check_list.length > 0 ||
            vm.manual_obrigatorio == 'variado' && vm.check_list_avancado.length > 0
          ))
        )

    vm.hasChecklistDocumentos = ->
      return hasChecklistDocumentos()

    vm.onDocumentosModeChange = ->
      onDocumentosModeChange()

    vm.hydrateManualDocumentos = ->
      hydrateManualDocumentos()

    vm.carregarChecklistDisponivel = ->
      loadChecklistDocumentosFromCurrentSelection()

    vm.removeItem = (index) ->
      vm.check_list.splice(index, 1);
      return

    vm.addCheckList = () ->
      return if vm.check_list_item == '' || !vm.check_list_item?
      unless vm.check_list.indexOf(vm.check_list_item) != -1
        vm.check_list.push(vm.check_list_item)
      vm.check_list_item = ''

      return

    vm.removeItemCheckListAvancado = (index) ->
      vm.check_list_avancado.splice(index, 1)

      return

    vm.addCheckListAvancado = () ->
      return if vm.check_list_item == '' || !vm.check_list_item?
      unless vm.check_list_avancado.indexOf(vm.check_list_item) != -1
        vm.check_list_avancado.push({nome: vm.check_list_item, quantidade: 1, obrigatorio: true})
      vm.check_list_item = ''

      return      



    # CALL INIT SETUP
    init()

    return


  # ANGULAR CONTROLLER
  angular.module('mainApp').controller 'ProcessoWorkflowNewEditController', ProcessoWorkflowNewEditController

  # ANGULAR INJECT DEPENDENCIES
  ProcessoWorkflowNewEditController.$inject = ['$http', '$scope', '$timeout']

  # END BLOCK SCRIPT
  return
